import { render, staticRenderFns } from "./FbStatusList.vue?vue&type=template&id=0698cd36&scoped=true"
import script from "./FbStatusList.vue?vue&type=script&lang=js"
export * from "./FbStatusList.vue?vue&type=script&lang=js"
import style0 from "./FbStatusList.vue?vue&type=style&index=0&id=0698cd36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0698cd36",
  null
  
)

export default component.exports